import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const usePinterestBusinessManagerStore = defineStore({
  id: 'pinterestBusinessManagerStore',
  state: () => ({
    pinterestBusinessManagers: [],
    pinterestBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getPinterestBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.pinterestBusinessManagersLoading = true

      try {
        const {data} = await axios.get('pinterest/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.pinterestBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.pinterestBusinessManagersLoading = false
      }
    },

    async createPinterestBusinessManager(payload) {
      this.error = null
      this.pinterestBusinessManagersLoading = true

      try {
        const {data} = await axios.post('pinterest/business-managers', payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.pinterestBusinessManagersLoading = false
      }
    },

    async updatePinterestBusinessManager(id, payload) {
      this.error = null
      this.pinterestBusinessManagersLoading = true

      try {
        let {data} = await axios.patch(`pinterest/business-managers/${id}`, payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.pinterestBusinessManagersLoading = false
      }
    },

    async updatePinterestBusinessManagerProviders(hash, payload) {
      const {data} = await axios.patch(`pinterest/business-managers/${hash}/providers`, payload)

      return data
    },

    async getPinterestProviders(filters = {}) {
      this.error = null
      this.loading = true

      try {
        const {data} = await axios.get('pinterest/providers', {params: filters})
        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.loading = false
      }
    },
  },
})
